module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szamlak3.a9be4a1e.jpg";